export default "__VITE_ASSET__Cus6TMV0__"